import React from 'react';
import { CheckCircle, Circle, ArrowRight } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { Card, CardContent } from '@/components/ui/card';

export default function WorkflowProgress({ totalSteps, completedSteps, currentStepOrder }) {
  const percentage = totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0;
  
  return (
    <Card className="border-2 border-blue-200 bg-blue-50/30">
      <CardContent className="pt-6">
        <div className="space-y-4">
          {/* Progress Header */}
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Workflow Progress</h3>
              <p className="text-sm text-gray-600">
                {completedSteps} of {totalSteps} steps completed
              </p>
            </div>
            <div className="text-3xl font-bold text-blue-600">
              {percentage}%
            </div>
          </div>
          
          {/* Progress Bar */}
          <Progress value={percentage} className="h-3" />
          
          {/* Step Indicators */}
          <div className="flex items-center justify-between pt-2">
            {Array.from({ length: Math.min(totalSteps, 8) }, (_, i) => i + 1).map((stepNum) => (
              <div key={stepNum} className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold ${
                    stepNum <= completedSteps
                      ? 'bg-green-600 text-white'
                      : stepNum === currentStepOrder
                      ? 'bg-blue-600 text-white ring-4 ring-blue-200'
                      : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {stepNum <= completedSteps ? (
                    <CheckCircle className="h-5 w-5" />
                  ) : (
                    stepNum
                  )}
                </div>
                <span className="text-xs text-gray-500 mt-1">{stepNum}</span>
              </div>
            ))}
            {totalSteps > 8 && (
              <div className="text-sm text-gray-500">+{totalSteps - 8} more</div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
